export default __webpack_public_path__ + "static/media/bgImage.92fc79b7.png";